import type { ReducedMotionPreference } from '../domain/progress'

/**
 * Applies the learner's motion preference to the document.
 *
 * The effective decision combines the stored preference with the OS setting:
 * - `system` follows the OS `prefers-reduced-motion`,
 * - `reduce` always reduces motion,
 * - `no-preference` allows motion (an explicit in-app opt-in).
 *
 * The result is written to `data-reduce-motion` on the root element; global CSS
 * disables transitions and animations when it is `"true"`.
 */

export function prefersReducedMotionOS(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

export function shouldReduceMotion(preference: ReducedMotionPreference): boolean {
  if (preference === 'reduce') return true
  if (preference === 'no-preference') return false
  return prefersReducedMotionOS()
}

export function applyMotionPreference(preference: ReducedMotionPreference): void {
  if (typeof document === 'undefined') return
  document.documentElement.dataset.reduceMotion = shouldReduceMotion(preference) ? 'true' : 'false'
}
